export default {
  LOGIN: "Login",
  FORGET_PASSWORD: "Forget Password",
  OTP_VERIFICATION: "OTP Verification",
  LOGOUT: "Logout",
  RESET_PASSWORD: "Reset Password",
  EDIT_PROFILE: "Edit Profile",
  CHANGE_PASSWORD: "Change Password",
};
